document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-confidence-strip]').forEach((strip) => {
    const items = Array.from(strip.querySelectorAll('.confidence-strip__item'));
    let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setInterval(() => {
        items.forEach((item) => item.classList.remove('is-active'));
        activeIndex = (activeIndex + 1) % items.length;
        items[activeIndex].classList.add('is-active');
      }, 1900);
    }

    const toggle = strip.querySelector('.confidence-strip__toggle');
    const policies = strip.querySelector('.confidence-strip__policies');
    if (toggle && policies) {
      toggle.addEventListener('click', () => {
        const isOpen = strip.classList.toggle('is-open');
        policies.hidden = !isOpen;
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    }
  });
});

